'use client';
import React, { useState } from 'react';
import styles from './DocTools.module.css';

// A small document toolbar: print, copy-all, and download-as-text. Operates on
// the rendered page body ([data-page-body]) so it needs no server data.
export const DocTools: React.FC<{ filename?: string; label?: string }> = ({
  filename = 'document.txt',
  label = 'Document',
}) => {
  const [copied, setCopied] = useState(false);

  const bodyText = () => {
    const el = document.querySelector<HTMLElement>('[data-page-body]');
    return (el?.innerText || el?.textContent || '').replace(/\n{3,}/g, '\n\n').trim();
  };

  const doCopy = async () => {
    const t = bodyText();
    try {
      if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(t);
      else {
        const ta = document.createElement('textarea');
        ta.value = t; ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select(); document.execCommand('copy'); document.body.removeChild(ta);
      }
      setCopied(true); setTimeout(() => setCopied(false), 1800);
    } catch { /* blocked */ }
  };

  const doDownload = () => {
    const blob = new Blob([bodyText()], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = filename;
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 2000);
  };

  return (
    <div className={styles.bar} role="toolbar" aria-label={`${label} tools`}>
      <span className={styles.label}>{label}</span>
      <div className={styles.actions}>
        <button type="button" className={styles.btn} onClick={() => window.print()} title="Print">🖨 Print</button>
        <button type="button" className={styles.btn} onClick={doCopy} title="Copy all text">{copied ? '✓ Copied' : '⧉ Copy'}</button>
        <button type="button" className={styles.btn} onClick={doDownload} title="Download as text">⤓ Download</button>
      </div>
    </div>
  );
};

export default DocTools;
